<template>
  <DetailWithIcon>
    <template #icon>
      <i class="icon-location" />
    </template>
    <template #detail-text>
      <LocationDetails :location="location" :hide-exact-location="hideExactLocation" :venue="venue" />
    </template>
  </DetailWithIcon>
</template>

<script>
import DetailWithIcon from './detail-with-icon'
import LocationDetails from './location-details'
export default {
  components: {
    DetailWithIcon,
    LocationDetails
  },
  props: {
    hideExactLocation: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      required: true
    },
    venue: {
      type: String,
      required: false
    }
  }
}
</script>

